<app-modal [modalTitle]="modalTitle" [modalId]="modalId" (closeModal)="onCloseModal()">
  <div modalBody>
    <form [formGroup]="createFolderForm">
      <div class="container">
        <div class="row">
          <div class="form-group">
            <label for="folder-input" class="form-label">{{ 'ENTER_NAME_FOR_FOLDER' | translate }}</label>
            <input
              #inputRef
              type=" "
              (keyup.enter)="createFolderForm.invalid ? $event.preventDefault() : onSubmit()"
              class="form-control input input-lg"
              [placeholder]="'FOLDER_NAME' | translate"
              formControlName="name"
              id="folder-input"
            />
            <div *ngIf="createFolderForm.get('name')?.hasError('maxlength')">
              <div class="text-danger">{{ 'MAX_50_CHAR' | translate }}</div>
            </div>
            <div *ngIf="createFolderForm.get('name')?.hasError('required') && createFolderForm.get('name')?.touched">
              <div class="text-danger">{{ 'ENTER_NAME_FOR_FOLDER' | translate }}</div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div modalFooter>
    <button #cancelButton class="btn btn-outline btn-primary btn-md btn-style mr-8" data-bs-dismiss="modal" (click)="onCloseModal()" id="cancel-btn">{{
      'CANCEL' | translate
    }}</button>
    <button class="btn btn-primary btn-md btn-style" [disabled]="createFolderForm.invalid" (click)="onSubmit()" id="create-btn"> {{ 'CREATE' | translate }} </button>
  </div>
</app-modal>
